import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon, DollarSignIcon, HomeIcon, HeartIcon } from 'lucide-react';
const pillars = [{
  icon: DollarSignIcon,
  title: 'PROVISIÓN',
  description: 'Cómo ajustar tu presupuesto en USD, entender los beneficios estatales y crear un fondo de emergencia real.'
}, {
  icon: ShieldIcon,
  title: 'PROTECCIÓN',
  description: 'Logística pura. Desde la seguridad en casa hasta cómo hablar con pediatras en inglés sin que se te escape nada.'
}, {
  icon: HeartIcon,
  title: 'PRESENCIA',
  description: 'El protocolo para salvar tu relación. Cómo ser el líder que calma la tormenta en casa, no el que la provoca.'
}];
export function SolutionSection() {
  return <section className="w-full bg-navy-dark py-16 md:py-24 px-4" data-id="element-149">
      <div className="max-w-6xl mx-auto" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-151">
          <h2 className="font-heading text-4xl md:text-5xl text-white mb-6" data-id="element-152">
            El Escudo de <span className="text-gold" data-id="element-153">3 Pilares</span>
          </h2>
          <p className="font-body text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-154">
            He creado PROYECTO PATRIARCA. No es un libro de cuentos. Es un
            manual de operaciones.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-155">
          {pillars.map((pillar, index) => {
          const Icon = pillar.icon;
          return <motion.div key={pillar.title} initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="bg-navy-medium border-2 border-gold/20 rounded-lg p-8 hover:border-gold/50 transition-colors duration-300" data-id="element-156">
                <div className="flex justify-center mb-6" data-id="element-157">
                  <div className="bg-gold/10 p-4 rounded-full" data-id="element-158">
                    <Icon className="w-12 h-12 text-gold" aria-hidden="true" data-id="element-159" />
                  </div>
                </div>
                <h3 className="font-heading text-2xl text-gold mb-4 text-center" data-id="element-160">
                  {pillar.title}
                </h3>
                <p className="font-body text-gray-300 leading-relaxed text-center" data-id="element-161">
                  {pillar.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}